export default "__VITE_ASSET__534850f5__"